import { Grid, Paper, Theme } from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'
import React, { FC } from 'react'

export interface OptionModel {
  title: string | JSX.Element
  isMobile?: boolean
  subtitle?: string | JSX.Element
  icon?: JSX.Element
  selected?: boolean
  handleOnClick?: any
  alignText?: string
  alignContent?: string
  borderBox?: boolean
  square?: boolean
  id?: string
}

export const Box: FC<OptionModel> = ({
  title,
  subtitle,
  icon,
  selected,
  handleOnClick,
  isMobile = false,
  alignText = 'center',
  alignContent = 'center',
  borderBox = true,
  square = false,
  id = '',
}) => {
  const getWidth = (mobile: boolean) => {
    if (!mobile) {
      return '136px'
    }
    return square ? 'calc(50vw - 32px)' : '90px'
  }
  const getHeight = (mobile: boolean) => {
    if (!mobile) {
      return '92px'
    }
    return square ? 'calc(50vw - 32px)' : '75px'
  }

  const useStyles = (mobile: boolean) =>
    makeStyles((_: Theme) =>
      createStyles({
        root: {
          width: getWidth(mobile),
          border: '0px',
        },
        paper: {
          textAlign: 'center',
          height: getHeight(mobile),
          width: getWidth(mobile),
          border: '1px solid #B7B7B9',
          boxSizing: borderBox ? 'border-box' : 'content-box',
          borderRadius: '4px',
          padding: '8px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        },
        pointer: {
          cursor: 'pointer',
        },
      })
    )
  const classes = useStyles(isMobile)()
  return (
    <div>
      <div
        onClick={handleOnClick}
        className={`${classes.pointer}`}
        id={id}
        data-testid="option-main-div"
      >
        <Grid className={`${classes.root}`}>
          <Paper className={`${classes.paper} ${selected && 'selected'}`}>
            <Grid container direction="column" alignContent={alignContent}>
              {icon && (
                <Grid
                  item
                  container
                  alignContent="center"
                  justifyContent="center"
                  alignItems="center"
                >
                  {icon}
                </Grid>
              )}
              <Grid item>
                <pichincha-typography
                  align={alignText}
                  variant="bodyText"
                  weight="bold"
                  weight_color="500"
                  class="bp-px-4"
                >
                  {title}
                </pichincha-typography>
              </Grid>
              {subtitle && (
                <Grid item>
                  <pichincha-typography
                    align={alignText}
                    variant="tinyText"
                    weight_color="500"
                    class="bp-px-4"
                  >
                    {subtitle}
                  </pichincha-typography>
                </Grid>
              )}
            </Grid>
          </Paper>
        </Grid>
      </div>
    </div>
  )
}
